import Typography from "../v2/typography";
import { SuccessMessageProps } from "./types";

/**
 * Component to show a success message after completed operation
 * @param interface
 * @returns a box with text.
 */
export const SuccessMessage = ({ message }: SuccessMessageProps) => (
  <div className="flex items-center min-h-50px border-l-4 border-l-green mt-2 pl-5 pr-4 py-2 bg-greyBackground transition-all duration-450 w-full shadow-md shadow-greyShadow text-green">
    <Typography variant="Lead">{message}</Typography>
  </div>
);
